// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__aiR2M","col":"styles_col__Pk9xt"};